import { render, staticRenderFns } from "./saleReturn.vue?vue&type=template&id=2ea8005c"
import script from "./saleReturn.vue?vue&type=script&lang=js"
export * from "./saleReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports